import React, { useState, useEffect } from 'react';

import { connect } from 'react-redux';
import { BaseStore } from 'src/store';
import { Media } from 'react-breakpoints';
import { breakpoints } from 'src/utils/breakpoints';
import { PagesStore, PageKeys } from 'src/modules/pages';
import {
  // LayoutCardList,
  LayoutCardSize,
  LayoutPage,
  LayoutCardListHeading,
  // LayoutCardType,
} from 'src/modules/layout';
import {
  GlobalImage,
  GlobalIcon,
  IconImage,
  ImageType,
  GlobalCta,
  GlobalBanner,
} from 'src/modules/global';
import { ArticlesInstagramOverview } from 'src/modules/articles';
import { LayoutBlockFullHero } from 'src/modules/layout';
import { Row, Col } from 'antd';
import { defaultHorizontalGutter } from 'src/utils/grid';
import { classes } from 'src/utils/styles';
import { colInstagramCardPropsHomePage } from 'src/utils/grid';
import { useIntl } from 'react-intl';
import { useLocale, getModelByOutputChannel } from 'src/modules/locale';
import { ArticleListingOverview, ArticleLinkPrefix } from 'src/modules/articles';
import { ArticlesInstagramEntity } from 'src/modules/articles/instagram/types';

import styles from './LayoutHomepage.module.scss';

interface LayoutHomepageProps extends PagesStore {
  seeMore?: any;
  page?: any;
  homePage: { instagrams: ArticlesInstagramEntity[] };
}

const LayoutHomepage: React.FunctionComponent<LayoutHomepageProps> = (props) => {
  const intl = useIntl();
  const { getLocalizedObject, outputChannel } = useLocale();

  const pageProperties = {
    title: intl.formatMessage({ id: 'homepage/head/page_title' }),
    description: intl.formatMessage({ id: 'homepage/head/meta_description' }),
  };

  const arrowSvg = <GlobalIcon image={IconImage.Link} className={styles.linkIcon} />;
  const instagrams = props.homePage.instagrams;

  // Workaround to force redraw since on SSG the content language or outputChannel doesn't update
  const [mountReRenderKey, setMountReRenderKey] = useState('home-not-mounted');
  useEffect(() => setMountReRenderKey('home-mounted'), []);

  const { homePage } = getLocalizedObject(props);
  const {
    hero,
    teaser_left_title,
    teaser_left_image,
    teaser_left_subline,
    teaser_left_cta,
    teaser_right_subline,
    teaser_right_title,
    teaser_right_cta,
    teaser_right_image,
    block_left_title,
    block_left_subline,
    block_left_image,
    block_left_cta,
    block_right_title,
    block_right_subline,
    block_right_image,
    block_right_cta,
    banner_top,
    banner_bottom,
  } = homePage.homepage;
  const articles = homePage.articles;

  const aboutImage = <GlobalImage type={ImageType.Raw} ratio={4 / 3} {...block_right_image} />;

  const bannerTopModel = getModelByOutputChannel(banner_top, outputChannel);
  const bannerBottomModel = getModelByOutputChannel(banner_bottom, outputChannel);

  console.log('___ NEXT_PUBLIC_VERCEL_URL', process.env.NEXT_PUBLIC_VERCEL_URL);

  return (
    <Media key={mountReRenderKey}>
      {({ currentBreakpoint } = { currentBreakpoint: 'xs' }) => (
        <LayoutPage {...pageProperties}>
          {hero && <LayoutBlockFullHero {...hero} />}

          <div className={styles.teaser}>
            <Row gutter={[defaultHorizontalGutter, 20]}>
              <Col xs={24} md={12} className={styles.column}>
                <div>
                  <GlobalImage type={ImageType.Raw} ratio={3 / 2} {...teaser_left_image} />
                </div>
                <h3>{teaser_left_title}</h3>
                <div
                  className={styles.description}
                  dangerouslySetInnerHTML={{ __html: teaser_left_subline }}
                />
                <GlobalCta {...teaser_left_cta} />
              </Col>
              <Col xs={24} md={12} className={styles.column}>
                <div className={styles.rightImage}>
                  <GlobalImage type={ImageType.Raw} ratio={3 / 2} {...teaser_right_image} />
                </div>
                <h3>{teaser_right_title}</h3>
                <div
                  className={styles.description}
                  dangerouslySetInnerHTML={{ __html: teaser_right_subline }}
                />
                <GlobalCta {...teaser_right_cta} />
              </Col>
            </Row>
          </div>
          {!!articles?.length && (
            <div className={styles.articles}>
              <LayoutCardListHeading
                title="homepage/magazine/title"
                link="/magazine"
                seeAll="homepage/magazine/see_more"
                svg={arrowSvg}
              />
              <ArticleListingOverview
                articles={articles}
                link={ArticleLinkPrefix.article}
                relatedOverview={false}
                oneRow={true}
                size={LayoutCardSize.Small}
              />
            </div>
          )}
          {!!bannerTopModel && (
            <div>
              <GlobalBanner {...bannerTopModel} />
            </div>
          )}
          <div className={styles.editorialBlock}>
            <Row gutter={[defaultHorizontalGutter, 20]}>
              <Col xs={16} md={8} className={classes([styles.column, styles.left])}>
                <GlobalImage
                  type={ImageType.Raw}
                  className={styles.editorialBlockImage}
                  ratio={3 / 4}
                  {...block_left_image}
                />
                <h3>{block_left_title}</h3>
                <div
                  className={styles.description}
                  dangerouslySetInnerHTML={{ __html: block_left_subline }}
                />

                <GlobalCta {...block_left_cta} />
              </Col>
              <Col
                xs={{ span: 20, offset: 4 }}
                md={{ span: 14, offset: 2 }}
                className={classes([styles.column, styles.right])}>
                {breakpoints[currentBreakpoint] < breakpoints.md && aboutImage}
                <div>
                  <h3>{block_right_title}</h3>
                  <div
                    className={styles.description}
                    dangerouslySetInnerHTML={{ __html: block_right_subline }}
                  />

                  <div className={styles.ctaBlock}>
                    <GlobalCta {...block_right_cta} />
                  </div>
                </div>
                {!(breakpoints[currentBreakpoint] < breakpoints.md) && aboutImage}
              </Col>
            </Row>
          </div>
          <div className={styles.instagram}>
            <LayoutCardListHeading
              title="page/magazine/instagram_title"
              link="/magazine/instagram"
              seeAll="page/magazine/instagram_show_more"
              svg={arrowSvg}
            />
            <ArticlesInstagramOverview
              colProps={colInstagramCardPropsHomePage}
              numPosts={4}
              instagramsSSG={instagrams}
              displayShowMore={false}
            />
          </div>
          {!!bannerBottomModel && (
            <div className={styles.bannerBottom}>
              <GlobalBanner {...bannerBottomModel} />
            </div>
          )}
        </LayoutPage>
      )}
    </Media>
  );
};

const mapStateToProps = (state: BaseStore) => {
  return {
    page: state.pages?.pages[PageKeys.Homepage],
    ...state.pages,
  };
};

export default connect(mapStateToProps)(LayoutHomepage);
